import React, {useEffect, useState} from 'react';
import Button from '../../Button/Button';
import './Horizontal.scss'

const Horizontal = (props) => {
    
    const { min, max, value, label, buttonText, showValue=false, onRangeChanged, callback } = props

    const [ rangeValue, setRangeValue ] = useState()

    useEffect( () => {
        setRangeValue(value ? value : min)
    }, [])

    const handleRangeValue = (e) =>{
        setRangeValue(e.target.value)
        if(onRangeChanged) onRangeChanged(e.target.value)
    }

    return (
        <div className="range-container">
            <div className="range-column">
                {label && 
                    <label>{label}</label> 
                }
                <input
                    orient='horizontal'
                    type="range"
                    min={min} value={rangeValue ? rangeValue : 0 }
                    max={max} onChange={handleRangeValue}/>
            </div>  
            <div className="range-column value">
                {showValue && 
                    <div className="range-value">
                        {rangeValue ? rangeValue : 0}
                    </div>
                }
                {callback && 
                    <Button className='small primary' text={buttonText} onClickHandle={()=>callback(rangeValue)} /> 
                }
            </div>
            
            
        </div>
    );
}
export default Horizontal;